class $e3c3cfae7ccd481e$export$8b624ca251eb0607 {
    constructor(wrapper){
        this.wrapper = wrapper;
        if (!this.wrapper) return;
        this.leftColumn = this.wrapper.querySelector('.wave-column-left');
        this.rightColumn = this.wrapper.querySelector('.wave-column-right');
        this.textItems = Array.from(this.wrapper.querySelectorAll('.animated-text'));
        this.imageWrapper = this.wrapper.querySelector('.image-thumbnail-wrapper');
        this.image = this.wrapper.querySelector('.image-thumbnail');
        this.isMobile = ()=>window.innerWidth <= 768;
        // Track the currently displayed src to avoid redundant fades
        this.currentSrc = '';
        this.init();
    }
    init() {
        // Seed the initial image immediately (first item in left column)
        const firstItem = this.textItems[0];
        if (firstItem) {
            const imgEl = firstItem.querySelector('.preload-img');
            const src = imgEl ? imgEl.src : firstItem.dataset.image;
            if (src) {
                this.showImage(src);
                firstItem.classList.add('focused');
            }
        }
        this.initEvents();
        this.render();
    }
    /** Sets image immediately with no guard — used for the initial seed */ showImage(src) {
        if (!src || !this.image) return;
        this.currentSrc = src;
        this.image.src = src;
        this.image.style.opacity = '1';
    }
    initEvents() {
        window.addEventListener('resize', ()=>this.render());
        this.textItems.forEach((item)=>{
            // ─── Desktop: hover image reveal ───────────────────────────
            item.addEventListener('mouseenter', ()=>{
                if (this.isMobile()) return;
                this.isHovering = true;
                const imgEl = item.querySelector('.preload-img');
                const src = imgEl ? imgEl.src : item.dataset.image;
                this.updateImage(src);
                this.textItems.forEach((t)=>t.classList.remove('focused'));
                item.classList.add('focused');
            });
            item.addEventListener('mouseleave', ()=>{
                if (this.isMobile()) return;
                this.isHovering = false;
            });
            // ─── Mobile: touch active-state feedback ───────────────────
            item.addEventListener('touchstart', ()=>{
                item.classList.add('is-touching');
            }, {
                passive: true
            });
            item.addEventListener('touchend', ()=>{
                setTimeout(()=>item.classList.remove('is-touching'), 200);
            }, {
                passive: true
            });
            item.addEventListener('touchcancel', ()=>{
                item.classList.remove('is-touching');
            }, {
                passive: true
            });
        });
    }
    render() {
        if (!this.wrapper) return;
        const speed = 0.15;
        const amplitude = window.innerWidth * 0.15;
        ScrollTrigger.create({
            trigger: this.wrapper,
            start: 'top bottom',
            end: 'bottom top',
            onUpdate: (self)=>{
                if (!this.isMobile()) this.animateWave(self.progress, speed, amplitude);
            }
        });
    }
    animateWave(progress, speed, amplitude) {
        this.textItems.forEach((item)=>{
            const rect = item.getBoundingClientRect();
            const centerY = window.innerHeight / 2;
            const itemCenterY = rect.top + rect.height / 2;
            const distFromCenter = (itemCenterY - centerY) / window.innerHeight;
            const isLeft = item.parentElement.classList.contains('wave-column-left');
            const direction = isLeft ? -1 : 1;
            const wave = Math.cos(distFromCenter * 3);
            const x = wave * amplitude * direction;
            gsap.set(item, {
                x: x
            });
            // Focus: highlight item closest to viewport centre
            if (!this.isHovering) {
                const dist = Math.abs(itemCenterY - centerY);
                if (dist < 100) {
                    if (!item.classList.contains('focused')) {
                        this.textItems.forEach((t)=>t.classList.remove('focused'));
                        item.classList.add('focused');
                        const imgEl = item.querySelector('.preload-img');
                        const src = imgEl ? imgEl.src : item.dataset.image;
                        this.updateImage(src);
                    }
                }
            }
        });
    }
    updateImage(src) {
        if (!src || !this.image) return;
        // Compare by basename only — avoids Parcel-hashed URL mismatch
        const newBasename = src.split('/').pop();
        const curBasename = this.currentSrc.split('/').pop();
        if (newBasename === curBasename) return;
        this.currentSrc = src;
        gsap.to(this.image, {
            opacity: 0,
            duration: 0.2,
            onComplete: ()=>{
                this.image.src = src;
                gsap.to(this.image, {
                    opacity: 1,
                    duration: 0.3
                });
            }
        });
    }
}
// Auto-init for all wrappers
document.addEventListener('DOMContentLoaded', ()=>{
    const wrappers = document.querySelectorAll('.dual-wave-wrapper');
    wrappers.forEach((wrapper)=>new $e3c3cfae7ccd481e$export$8b624ca251eb0607(wrapper));
});


export {$e3c3cfae7ccd481e$export$8b624ca251eb0607 as DualWaveAnimation};
//# sourceMappingURL=Personal_Portfolio_2023.0fb89594.js.map
